<template>
  <div class="rfmodal-input-wrapper">
    <label class="rfmodal-input-label" :style="consentStyle">
      <input
        type="checkbox"
        :checked="value"
        @change="emit('update:modelValue', $event.target.checked)"
      />
      <span v-html="actions.consent_text" />
    </label>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({ actions: Object, modelValue: Boolean });

const emit = defineEmits(["update:modelValue"]);

const consentStyle = computed(() => ({
  "font-size": props.actions.consent_font_size,
  "color": props.actions.consent_font_color,
}));
</script>

<style scoped lang="scss">
.rfmodal-input-wrapper {
  padding: 0 0 15px;
}
.rfmodal-input-label {
  cursor: pointer;
}
input[type="checkbox"] {
  margin-right: 8px;
  vertical-align: middle;
}
span {
  vertical-align: middle;
}
</style>
